/** The Type cell and four rate cells of a roster row. A row the API sent no
 *  rates for shows a dash in each. */
import type { CurrentRate } from '../../../api/staff-pay-rates';
import { PAY_RATE_ROLES } from '../pay-rates/pay-rate-format';

import StaffDash from './StaffDash';
import StaffRateCell from './StaffRateCell';
import StaffTypeBadge from './StaffTypeBadge';

const PAY_CELL = 'px-3 py-3 text-center text-sm text-bark-900 dark:text-[#e8ece9]';

export default function StaffPayCells({
  rates,
  isSalaried,
}: {
  rates: CurrentRate[] | undefined;
  isSalaried: boolean;
}) {
  return (
    <>
      <td className="px-3 py-3 text-center">
        {rates ? <StaffTypeBadge isSalaried={isSalaried} /> : <StaffDash />}
      </td>
      {PAY_RATE_ROLES.map((role) => (
        <td key={role} className={PAY_CELL}>
          {rates ? (
            <StaffRateCell rate={rates.find((r) => r.role === role)} isSalaried={isSalaried} />
          ) : (
            <StaffDash />
          )}
        </td>
      ))}
    </>
  );
}
